import DisplayModeAction from './DisplayModeAction';

export default DisplayModeAction;
